"use client";

import PageError from "@/app/components/PageError";
import { useAuth } from "@/lib/auth";
import { getLSClientId } from "@/lib/pariette";
import axios from "axios";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations("errors");
  const { user } = useAuth({ middleware: "auth" });
  const pathname = usePathname();
  useEffect(() => {
    let errorTitle = pathname?.substring(1);
    if (user) errorTitle += " (" + user.email + ")";
    if (!errorTitle) errorTitle = (user?.email ?? "") + " app error";
    const logError = async () => {
      try {
        const errorData = {
          title: errorTitle,
          data: JSON.stringify({
            message: error.message,
            stack: error.stack,
            digest: error.digest,
            url: window.location.href,
            userAgent: navigator.userAgent,
            userAgentData: "userAgentData" in navigator ? navigator.userAgentData : undefined,
            clientId: getLSClientId(),
            appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
            timestamp: new Date().toISOString(),
          }),
        };
        await axios.post("https://test.aysoft.de/api/log", errorData);
      } catch (err) {
        console.error("Failed to send log to server:", err);
      }
    };

    logError();
    console.error("Global Error Caught:", error);
  }, [error, pathname, user]);

  return (
    <PageError
      errors={{
        code: "500",
        title: t("application_error"),
        message: t("something_went_wrong_logged"),
      }}
      reset={reset}
    />
  );
}
